module.exports = __webpack_public_path__ + "static/media/86.193b07fe.jpg";